export const NODE_ENV = process.env.NODE_ENV === 'development' ? 'development' : 'production'
export const NODE_ENV_DEV = NODE_ENV === 'development'
export const NODE_ENV_PROD = NODE_ENV === 'production'
